import { render, staticRenderFns } from "./MemberPage.vue?vue&type=template&id=0b9e0a34&"
import script from "./MemberPage.vue?vue&type=script&lang=ts&"
export * from "./MemberPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports